import { ActionIdentifiersListDto } from "api/dtos/ActionIdentifiersDto";
import axiosInstance from "api/utils/axiosInstance";
import { constructURL, URLS } from "api/utils/baseUrls";

const baseUrl = URLS.actionIdentifiers;

const getActionIdentifiers = async () => {
  const url = constructURL(baseUrl);

  try {
    const res = await axiosInstance.get(url);
    const data = ActionIdentifiersListDto.fromApi(res.data);
    return data;
  } catch (error) {
    console.error("Error fetching charts:", error);
    throw error;
  }
};

export const actionIdentifiersApi = {
  fetchAll: getActionIdentifiers,
};
